<template>
  <div>
    <table
      class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12"
    >
      <thead class="table-active">
        <tr>
          <th
            scope="col"
            class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1"
          >
            ID
          </th>
          <th
            scope="col"
            class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3"
          >
            Fecha de nombramiento
          </th>
          <th
            scope="col"
            class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3"
          >
            Fecha de retiro
          </th>
          <th
            scope="col"
            class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
          >
            Nombre
          </th>
          <th
            scope="col"
            class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1"
          >
            Estado
          </th>
          <th
            scope="col"
            class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
          >
            Acciones
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr
          v-for="(item, i) in responsible"
          :key="i + `${item.id}${item.created_at}${new Date().toString()}`"
        >
          <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
            <b>{{ item.sgsst_id }}</b>
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-left">
            {{ dateConvert(item.sgsst_appointment_date) }}
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-left">
            {{ dateConvert(item.sgsst_withdrawal_date) }}
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-left">
            {{ item.sgsst_name }}
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
            <span
              class="badge float"
              :class="{
                'badge-soft-warning':
                  getStatus(item.status, item.sgsst_withdrawal_date) == 2,
                'badge-soft-danger':
                  getStatus(item.status, item.sgsst_withdrawal_date) == 0 ||
                  item.status == 0,
                'badge-soft-success':
                  getStatus(item.status, item.sgsst_withdrawal_date) == 1 &&
                  item.status == 1,
              }"
            >
              {{
                getStatus(item.status, item.sgsst_withdrawal_date) == 1 &&
                item.status == 1
                  ? "Activo"
                  : "Inactivo"
              }}
            </span>
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
            <div class="col-sm-12">
              <b-dropdown
                variant="primary"
                :disabled="
                  (!getRole('Editar') && !getRole('Consultar')) || !allowAccess()
                "
              >
                <template v-slot:button-content>
                  <i class="mdi mdi-eye"></i>
                </template>
                <b-dropdown-item
                  :disabled="!getRole('Editar') || !allowAccess()"
                  :to="{ path: `/forms/responsable-sg/editar/${item.sgsst_id}` }"
                  >Editar
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="getRole('Consultar', [1, 2])"
                  :disabled="!item.certificate || !allowAccess()"
                  @click="print(item.certificate)"
                >
                  Descargar certificado
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <Pagination
      ref="paginator"
      :search="search"
      @fetch="(items) => (responsible = items)"
    />
  </div>
</template>

<script>
import Pagination from "./ResponsibleLogPagination";
import { dateFormat } from "@/utils/helpers/format";
import { isActive } from "@/utils/helpers/check";
import ItemAPI from "@/services/items/itemsAPI";

export default {
  components: { Pagination },
  data() {
    return {
      responsible: [],
      search: null,
      itemData: null,
    };
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(1)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to convert the date to a format that is easier to read.
     * @param {string} date - The date to be converted.
     */
    dateConvert(date) {
      return dateFormat(date);
    },

    /**
     * This method returns the status of the responsible
     * @param {string} date - The withdrawal date of the responsible
     * @return {number} - The status of the responsible
     */
    getStatus(status, date) {
      if (status && date) {
        return isActive(status, date) ? 1 : 0;
      } else {
        return 1;
      }
    },

    /**
     * This method allows to download the certificate of the responsible
     * @return {Boolean} True if the user has the permission to download the certificate or false if not
     */
    allowsDownload() {
      return (
        this.$store.state.auth.info.role === 1 || this.$store.state.auth.info.role === 2
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to download the certificate associated.
     * @param {String} certificate
     */
    print(url) {
      if (url) {
        window.location.href = url;
      }
    },
  },
  mounted() {
    this.getItemData();
  },
};
</script>
